import { NextPageContext } from 'next'
import {
  PlatformConfig,
  getValidBasePathForHost,
  getOpCoMetaConfig,
  getPlatformConfigFromCookies,
  getWhitelabelOpCoForHost,
  isAviosHostValid,
  validateOpCoLocale,
} from '@reward-platform/platform-config'
import { PlatformError } from '~/utils/errors'
import { getCookiesForClientOrServer, getHostForClientOrServer } from './pageContext.utils'

export const getPlatformBasePathFromPageContext = (context: NextPageContext): string => {
  try {
    const requestHost = getHostForClientOrServer(context, true)
    return getValidBasePathForHost(requestHost) ?? ''
  } catch (error) {
    if (error instanceof PlatformError) {
      error.logRequestToDatadog(context.req)
    }

    return ''
  }
}

export const getPlatformConfigFromPageContext = (context: NextPageContext): PlatformConfig => {
  try {
    const requestHost = getHostForClientOrServer(context, true)
    const maybeWhitelabelOpCo = getWhitelabelOpCoForHost(requestHost)
    if (maybeWhitelabelOpCo) {
      const defaultMeta = getOpCoMetaConfig(maybeWhitelabelOpCo)
      return {
        opCo: maybeWhitelabelOpCo,
        locale: validateOpCoLocale(maybeWhitelabelOpCo, context.locale),
        market: defaultMeta.defaultCountryCode,
        theme: defaultMeta.whitelabelTheme,
        buildType: 'whitelabel',
      }
    }

    if (isAviosHostValid(requestHost)) {
      const cookies = getCookiesForClientOrServer(context)
      const cookieConfig = getPlatformConfigFromCookies(cookies)
      // until cookie strategy is set up properly on avios.com we will use the router as the source of truth
      const validContextLocale = validateOpCoLocale(cookieConfig.opCo, context.locale)
      const basePath = getPlatformBasePathFromPageContext(context)
      return {
        ...cookieConfig,
        locale: validContextLocale,
        basePath,
        buildType: 'avios',
      }
    }

    throw new PlatformError(`host headers were missing or invalid - host: ${requestHost}`)
  } catch (error) {
    if (error instanceof PlatformError) {
      error.logRequestToDatadog(context.req)
    }

    throw error
  }
}
